import React, { useState, useEffect,useCallback } from 'react';
import { graphic, time } from 'echarts';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../css/calendar.css';

import { Get, GetList } from '../lib/DeviceData';
import { GetList as GetListPush } from '../lib/Push';
import { calculateAge, gapTime, secToString, dateLang } from '../lib/Common';
import moment from 'moment';

import HistoryLog from '../components/history_log';

const pushImage = {
    HEART: 'heart',
    RESP: 'breath',
    FSR: 'oxygen',
    HEARTE: 'heart_dise',
    RESPE: 'breath_dise',
    SLEEP: 'sleep_dise',
};

const MonitoringDetailBottom = props => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [data, setData] = useState();
    const [date, setDate] = useState(moment().subtract(1, 'day').format('YYYY-MM-DD'));
    const [items, setItems] = useState([]);
    const [selectedTime, setSelectedTime] = useState('');
    const [historySize, setHistorySize] = useState(60);

    const [timeData, setTimeData]=useState(undefined);

    const device_no=props.data?.device_no;


    const selectTime=[
        {value:'',name:t('시간 선택')},
        {value:'0',name:'AM 00'},
        {value:'1',name:'AM 01'},
        {value:'2',name:'AM 02'},
        {value:'3',name:'AM 03'},
        {value:'4',name:'AM 04'},
        {value:'5',name:'AM 05'},
        {value:'6',name:'AM 06'},
        {value:'7',name:'AM 07'},
        {value:'8',name:'AM 08'},
        {value:'9',name:'AM 09'},
        {value:'10',name:'AM 10'},
        {value:'11',name:'AM 11'},
        {value:'12',name:'PM 12'},
        {value:'13',name:'PM 01'},
        {value:'14',name:'PM 02'},
        {value:'15',name:'PM 03'},
        {value:'16',name:'PM 04'},
        {value:'17',name:'PM 05'},
        {value:'18',name:'PM 06'},
        {value:'19',name:'PM 07'},
        {value:'20',name:'PM 08'},
        {value:'21',name:'PM 09'},
        {value:'22',name:'PM 10'},
        {value:'23',name:'PM 11'}
    ];

        
    useEffect(() => {
        if (device_no) {
            Get(device_no, date, res => {
                setData(res);
            });

            GetListPush({ device_no, date }, res => {
                setItems(res);
            });

        }
    }, [props.data, date]);



    const handleSelect = (e) => {

        // console.log(`changed pre selected: ${preSelectedTime}`);

        // setPreSelectedTime(selectedTime);
        // setSelectedTime(`${parseInt(e.currentTarget.value) + 1}`);   
        
        // setTimeData(prevState =>({...prevState, }));

        setSelectedTime(e.currentTarget.value);
    };
    useEffect(() => {
        setTimeData({
            device_no,
            date,
            time: selectedTime,
            size: historySize,
        });
    }, [selectedTime, date, device_no, historySize]);

    // useEffect(() => {
    //     // console.log(preSelectedTime);
    //     // console.log(selectedTime);
    //     // if(timeData === undefined) {
    //     //     console.log(preSelectedTime);
    //     //     console.log(selectedTime);
    //     //     setSelectedTime('');   
    //     //     setTimeData({
    //     //         "device_no" : device_no,
    //     //         "date" : date,
    //     //         "time" : ''
    //     //     });
    //     // }else {
    //     //     console.log(preSelectedTime);
    //     //     console.log(selectedTime);

    //     //     if (preSelectedTime !== selectedTime){
    //     //         setTimeData({
    //     //             "device_no" : device_no,
    //     //             "date" : date,
    //     //             "time" : selectedTime
    //     //         });
    //     //         setPreSelectedTime(selectedTime);
    //     //     }
    //     // }

    //     console.log(preSelectedTime);
    //     console.log(selectedTime);

    //     if (preSelectedTime !== selectedTime){
    //         setPreSelectedTime(selectedTime);
    //         setTimeData({
    //             "device_no" : device_no,
    //             "date" : date,
    //             "time" : selectedTime
    //         });
    //     }

    //     console.log(timeData);
    // },[selectedTime, timeData]);



    return (
        <section className="monitoring_calendar_box">
            <h4>{t('달력')}</h4>

            <div className="information_box">
                <div className="calendar_box">
                    <Calendar
                        formatDay={(locale, date) => date.toLocaleString('en', { day: 'numeric' })}
                        showNeighboringMonth={false}
                        // maxDate={moment().subtract(1, 'day').toDate()}
                        maxDate={moment().toDate()}
                        onChange={date => {
                            setDate(moment(date).format('YYYY-MM-DD'));
                        }}
                        value={moment(date).toDate()}
                    />
                </div>

                <div className="data_box">
                    <dl>
                        <dt>{t('선택날짜')}</dt>
                        <dd>
                            <span className="date">
                                <b>{moment(data?.reg_date ? data?.reg_date : date).format('MM.DD')}</b> {t(dateLang[moment(date).locale('kr').format('ddd')])}
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>{t('평균생체지표')}</dt>
                        <dd>
                            <div className="de_info">
                                <span className="heart">
                                    <b>{data?.heart_avg ? parseFloat(data.heart_avg).toFixed(1) : 0}</b> BPM
                                </span>
                                <span className="breath">
                                    <b>{data?.resp_avg ? parseFloat(data.resp_avg).toFixed(1) : 0}</b> BPM
                                </span>
                                <span className="oxygen" style={{display:"none"}}>
                                    <b>{data?.apnea_avg ? parseFloat(data.apnea_avg).toFixed(1) : 0}</b> %
                                </span>
                                <span className="time">
                                    <b>{data?.countDay ? secToString(data?.countDay) : ''}</b>
                                </span>
                            </div>
                        </dd>
                    </dl>
                    {/* <dl>
                        <dt>{t('긴급알람 내용')}</dt>
                        <dd>
                            <ul className="alrm_list">
                                {items.map(x => {
                                    return (
                                        <li>
                                            <p className="icon">
                                                <span className={`icons circle ${pushImage[x.type]}`}></span>
                                            </p>
                                            <p className="tit">{t(x.title)}</p>
                                            <p className="decs">{t(x.message)}</p>
                                            <p className="data">{moment().format('YYYY. MM. DD')}</p>
                                        </li>
                                    );
                                })}

                                {items.length === 0 && (
                                    <li>
                                        <p className="tit">{t('없음')}</p>
                                    </li>
                                )}
                            </ul>
                        </dd>
                    </dl> */}
                    <dl className="hori_dl">
                        <dt>
                            {moment(data?.reg_date ? data?.reg_date : date).format('MM')}
                            {' ' + t('월 효심 총 사용 시간')}
                        </dt>
                        <dd>{data?.countMonth ? secToString(data?.countMonth) : ''}</dd>
                    </dl>
                    <dl className="history_log">
                        <h2 className='history_title'>History</h2>
                        <div className="history_controls" style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                            <select className='timeSelect' onChange={handleSelect} value={selectedTime} style={{ flex: 1 }}>
                                {selectTime.map((item) =>{
                                   return <option value={item.value} key={item.value}>
                                        {item.name}
                                    </option>;
                                })}
                            </select>
                            <select
                                className='timeSelect'
                                value={historySize}
                                onChange={e => setHistorySize(Number(e.target.value))}
                                style={{ width: 140, flex: '0 0 140px' }}
                                title="size"
                            >
                                <option value={30}>size 30</option>
                                <option value={60}>size 60</option>
                                <option value={120}>size 120</option>
                                <option value={360}>size 360</option>
                            </select>
                        </div>
                        <HistoryLog data={timeData}/>
                    </dl>
                </div> 
            </div>
        </section>
    );
};

export default MonitoringDetailBottom;
